// src/data/managementData.js

export const managementData = [
  {
    id: 1,
    name: 'Vio',
    title: {
      de: '1. Vorsitzende',
      en: 'President'
    },
    image: '/assets/vio.jpg',
    description: {
      de: 'Im Vorstand ist sie gelandet, weil sie Dinge gerne ins Rollen bringt. Vio ist der Ansicht, dass es unsere Sportgemeinschaft verdient, dass alle gemeinsam kontinuierlich für qualitativ hochwertiges Training und die Weiterentwicklung des Vereins Sorge tragen.',
      en: 'She joined the board because she likes to get things moving. Vio believes that our sports community deserves everyone working together continuously to ensure high-quality training and the further development of the club.'
    }
  },
  {
    id: 2,
    name: 'Sabrina',
    title: {
      de: '2. Vorsitzende',
      en: 'Vice President'
    },
    image: '/assets/sabrina.jpg',
    description: {
      de: 'Sabrina war bereits in Australien für fünf Jahre Mitglied in einem Volleyball-Club, drei Jahre war sie Teil des Vorstands. Davon zwei Jahre als Vertreterin der Spielerinnen und ein Jahr als Sekretärin. Der Verein hatte fast 700 Mitglieder an drei Standorten - da wurde schnell klar, wie viel Leidenschaft und Organisation notwendig ist, um einen Verein am Laufen zu halten. Ihre Stärke im Vorstand ist, Verbesserungspotentiale zu erkennen, mit gutem Beispiel voranzugehen und Aufgaben an die geeignetsten Menschen zu vergeben, damit alles effektiv und reibungslos abläuft.',
      en: 'Sabrina was already a member of a volleyball club in Australia for five years, serving on the board for three years. She spent two years as a player representative and one year as secretary. With nearly 700 members across three locations, it quickly became clear how much passion and organization is needed to keep a club running. Her strength on the board is identifying areas for improvement, leading by example, and delegating tasks to the most suitable people to ensure everything runs effectively and smoothly.'
    }
  },
  {
    id: 3,
    name: 'David',
    title: {
      de: 'Schatzmeister',
      en: 'Treasurer'
    },
    image: '/assets/david.jpg',
    description: {
      de: 'David hat Bock auf Sport – am liebsten mit netten Leuten zusammen. Und das gibt es bei Phoenix Athletics. ' +
          'Ihm gefällt sehr, was die Gründer*innen des Vereins auf die Beine gestellt haben. Deshalb will er nicht nur an den Trainings teilnehmen, sondern aktiv helfen, den Verein weiterzuentwickeln. Daher engagiert sich David als Kassenwart.',
      en: 'David enjoys being active – preferably together with nice people. And that’s exactly what Phoenix Athletics offers. ' +
          'He really likes what the founders of the club have built. That’s why he doesn’t just want to take part in the training sessions, but also actively help develop the club further. For this reason, David is involved as the club’s treasurer.'
    }
  },
];

// The description field has been added for future UI implementation
// Update with your actual management team descriptions